import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';
import { currencyPrecision, percentPrecision } from '@ideapa/common-utils';

export const ENTITY = 'perimetro';
export const ENTITY_PLURAL = 'Perimetro di consolidamento';

export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Ragione Sociale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'gap.partecipataEnte.partecipata.ragioneSociale',
  },
  {
    elementLabel: 'Incidenza Attivo',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    precision: currencyPrecision,
    field: 'valoreParametro1',
    minWidth: 110,
    maxWidth: 150,
  },
  {
    elementLabel: 'Incidenza Attivo %',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    field: 'percentualeParametro1',
    contentAlignment: ContentAlignmentEnum.Right,
    precision: percentPrecision,
    minWidth: 110,
    maxWidth: 150,
  },
  {
    elementLabel: 'Patrimonio Netto',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    precision: currencyPrecision,
    field: 'valoreParametro2',
    minWidth: 110,
    maxWidth: 170,
  },
  {
    elementLabel: 'Patrimonio Netto %',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    field: 'percentualeParametro2',
    contentAlignment: ContentAlignmentEnum.Right,
    precision: percentPrecision,
    minWidth: 110,
    maxWidth: 170,
  },
  {
    elementLabel: 'Ricavi Gestione Caratteristica',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    field: 'valoreParametro3',
    contentAlignment: ContentAlignmentEnum.Right,
    precision: currencyPrecision,
    minWidth: 110,
  },
  {
    elementLabel: 'Ricavi Gestione Caratteristica %',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    field: 'percentualeParametro3',
    contentAlignment: ContentAlignmentEnum.Right,
    precision: percentPrecision,
    minWidth: 110,
  },
  {
    elementLabel: 'Motivo Inclusione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'motivoInclusione',
  },
  {
    elementLabel: 'Motivo Esclusione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'motivoEsclusione',
  },
];

export const gridColumns2: EntityListField[] = [
  {
    elementLabel: 'Ragione Sociale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'gap.partecipataEnte.partecipata.ragioneSociale',
  },
  {
    elementLabel: '% Possesso Diretta',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'gap.partecipataEnte.percentualePossessoDiretta',
    precision: percentPrecision,
  },
  {
    elementLabel: '% Possesso Totale',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'gap.partecipataEnte.percentualePossessoTotale',
    precision: percentPrecision,
  },
  {
    elementLabel: 'Motivo Esclusione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'motivoEsclusione',
  },
];

export const gridColumns3: EntityListField[] = [
  {
    elementLabel: 'Ragione Sociale',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'gap.partecipataEnte.partecipata.ragioneSociale',
  },
  {
    elementLabel: '% Possesso Diretta',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'gap.partecipataEnte.percentualePossessoDiretta',
    precision: percentPrecision,
  },
  {
    elementLabel: '% Possesso Totale',
    filterType: FilterType.number,
    fieldType: FieldType.percent,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'gap.partecipataEnte.percentualePossessoTotale',
    precision: percentPrecision,
  },
  {
    elementLabel: 'Tipologia Consolidamento',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'tipologiaConsolidamento',
  },
  {
    elementLabel: 'Motivo Inclusione',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'motivoInclusione',
  },
];
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
